import ReportingIcon from '@/components/icons/navigations/ReportingIcon.vue'
import CampaignIcon from '@/components/icons/navigations/CampaignIcon.vue'
import TrackingNumbersIcon from '@/components/icons/navigations/TrackingNumbersIcon.vue'
import NumberPoolsIcon from '@/components/icons/navigations/NumberPoolsIcon.vue'
import DestinationIcon from '@/components/icons/navigations/DestinationIcon.vue'
import VendorIcon from '@/components/icons/navigations/VendorIcon.vue'
import BuyerIcon from '@/components/icons/navigations/BuyerIcon.vue'
import TrafficSourceIcon from '@/components/icons/navigations/TrafficSourceIcon.vue'
import CallFlowsIcon from '@/components/icons/navigations/CallFlowsIcon.vue'
import IntegrationIcon from '@/components/icons/navigations/IntegrationIcon.vue'
import CustomParametersIcon from '@/components/icons/navigations/CustomParametersIcon.vue'
import LeadsIcon from '@/components/icons/navigations/LeadsIcon.vue'
import RtbLogIcon from '@/components/icons/navigations/RtbLogIcon.vue'
import PingPostLogIcon from '@/components/icons/navigations/PingPostLogIcon.vue'
import VoipShieldIcon from '@/components/icons/navigations/VoipShieldIcon.vue'
import TcpaShieldIcon from '@/components/icons/navigations/TcpaShieldIcon.vue'
import BlockedNumbersIcon from '@/components/icons/navigations/BlockedNumbersIcon.vue'
import OffersIcon from '@/components/icons/navigations/OffersIcon.vue'
import RequestsIcon from '@/components/icons/navigations/RequestsIcon.vue'
import GlobalOffersIcon from '@/components/icons/navigations/GlobalOffersIcon.vue'
import DisputeIcon from '@/components/icons/navigations/DisputeIcon.vue'

import { ROUTES } from '@/constants/routes'
import { ROUTER_PARAMS_NAMES } from '@/constants/routerParamsNames'
import { PERMISSION_NAMES } from '@/constants/workspace/permissionSettings'

const reporting = {
    id: 1,
    name: 'Reporting',
    routeName: ROUTES.reporting,
    paramsNames: [ROUTER_PARAMS_NAMES.workspace],
    isOpenSub: false,
    isFirstLoad: true,
    ai: true,
    icon: () => ReportingIcon,
}

const globalOffers = {
    id: 33,
    name: 'Global Offers',
    routeName: ROUTES.manageGlobalOffers,
    paramsNames: [ROUTER_PARAMS_NAMES.workspace],
    permissions: [PERMISSION_NAMES.view_global_offers],
    icon: () => GlobalOffersIcon,
}

export const CALL_MENU_ROUTES_MANAGER = [
    reporting,
    { divider: true, id: 'd-top' },
    {
        section: 'TRACKING',
        id: 's-tracking',
        isOpenSection: true,
        isFirstLoadSection: true,
        items: [
            {
                id: 10,
                name: 'Campaigns',
                routeName: ROUTES.manageCampaigns,
                paramsNames: [ROUTER_PARAMS_NAMES.workspace],
                permissions: [PERMISSION_NAMES.view_campaigns],
                icon: () => CampaignIcon,
            },
            {
                id: 11,
                name: 'Call Flows',
                routeName: ROUTES.callFlows,
                paramsNames: [ROUTER_PARAMS_NAMES.workspace],
                permissions: [PERMISSION_NAMES.view_call_flows],
                icon: () => CallFlowsIcon,
            },
            {
                id: 12,
                name: 'Tracking Numbers',
                routeName: ROUTES.manageNumbers,
                paramsNames: [ROUTER_PARAMS_NAMES.workspace],
                permissions: [PERMISSION_NAMES.view_phone_numbers],
                icon: () => TrackingNumbersIcon,
            },
            {
                id: 13,
                name: 'Number Pools',
                routeName: ROUTES.managePools,
                paramsNames: [ROUTER_PARAMS_NAMES.workspace],
                permissions: [PERMISSION_NAMES.view_phone_number_pools],
                icon: () => NumberPoolsIcon,
            },
            {
                id: 14,
                name: 'Destinations',
                icon: () => DestinationIcon,
                isOpenSub: false,
                isFirstLoad: true,
                paramsNames: [ROUTER_PARAMS_NAMES.workspace],
                permissions: [PERMISSION_NAMES.view_destinations, PERMISSION_NAMES.view_destination_groups],
                subMenu: [
                    {
                        name: 'Manage Destinations',
                        routeName: ROUTES.manageDestinations,
                        paramsNames: [ROUTER_PARAMS_NAMES.workspace],
                        permissions: [PERMISSION_NAMES.view_destinations],
                    },
                    {
                        name: 'Manage Groups',
                        routeName: ROUTES.manageDestinationGroups,
                        paramsNames: [ROUTER_PARAMS_NAMES.workspace],
                        permissions: [PERMISSION_NAMES.view_destination_groups],
                    },
                ],
            },
        ],
    },
    { divider: true, id: 'd-tracking' },
    {
        section: 'Connections',
        id: 's-connections',
        isOpenSection: true,
        isFirstLoadSection: true,
        items: [
            {
                id: 20,
                name: 'Integrations',
                routeName: ROUTES.manageIntegrations,
                paramsNames: [ROUTER_PARAMS_NAMES.workspace],
                permissions: [PERMISSION_NAMES.view_integrations],
                icon: () => IntegrationIcon,
            },
            {
                id: 21,
                name: 'Traffic Sources',
                routeName: ROUTES.manageTrafficSources,
                paramsNames: [ROUTER_PARAMS_NAMES.workspace],
                permissions: [PERMISSION_NAMES.view_traffic_sources],
                icon: () => TrafficSourceIcon,
            },
            {
                id: 22,
                name: 'Custom Parameters',
                routeName: ROUTES.customParameters,
                paramsNames: [ROUTER_PARAMS_NAMES.workspace],
                permissions: [PERMISSION_NAMES.view_custom_parameters],
                icon: () => CustomParametersIcon,
            },
        ],
    },
    { divider: true, id: 'd-connections' },
    {
        section: 'EXCHANGE',
        id: 's-exchange',
        isOpenSection: true,
        isFirstLoadSection: true,
        items: [
            {
                id: 30,
                name: 'Buyers',
                routeName: ROUTES.manageBuyers,
                paramsNames: [ROUTER_PARAMS_NAMES.workspace],
                permissions: [PERMISSION_NAMES.view_buyers],
                icon: () => BuyerIcon,
            },
            {
                id: 31,
                name: 'Vendors',
                routeName: ROUTES.manageVendors,
                paramsNames: [ROUTER_PARAMS_NAMES.workspace],
                permissions: [PERMISSION_NAMES.view_vendors],
                icon: () => VendorIcon,
            },
            {
                id: 32,
                name: 'Disputes',
                routeName: ROUTES.disputes,
                paramsNames: [ROUTER_PARAMS_NAMES.workspace],
                permissions: [PERMISSION_NAMES.view_disputes],
                icon: () => DisputeIcon,
            },
            // globalOffers,
        ],
    },
    { divider: true, id: 'd-exchange' },
    {
        section: 'ACTIVITY',
        id: 's-activity',
        isOpenSection: true,
        isFirstLoadSection: true,
        items: [
            {
                id: 40,
                name: 'RTB Log',
                routeName: ROUTES.rtbLog,
                paramsNames: [ROUTER_PARAMS_NAMES.workspace],
                permissions: [PERMISSION_NAMES.view_rtb_bid_log],
                icon: () => RtbLogIcon,
            },
            {
                id: 41,
                name: 'Ping/Post Log',
                routeName: ROUTES.pingPostLog,
                paramsNames: [ROUTER_PARAMS_NAMES.workspace],
                permissions: [PERMISSION_NAMES.view_ping_log],
                icon: () => PingPostLogIcon,
            },
            {
                id: 42,
                name: 'Lead Details',
                routeName: ROUTES.manageLeads,
                paramsNames: [ROUTER_PARAMS_NAMES.workspace],
                permissions: [PERMISSION_NAMES.view_leads],
                icon: () => LeadsIcon,
            },
        ],
    },
    { divider: true, id: 'd-activity' },
    {
        section: 'SUPPRESSION',
        id: 's-suppression',
        isOpenSection: true,
        isFirstLoadSection: true,
        items: [
            {
                id: 50,
                name: 'VoIP Shield',
                routeName: ROUTES.voipShield,
                paramsNames: [ROUTER_PARAMS_NAMES.workspace],
                permissions: [PERMISSION_NAMES.view_voip_black_lists],
                icon: () => VoipShieldIcon,
            },
            {
                id: 51,
                name: 'TCPA Shield',
                routeName: ROUTES.tcpaShield,
                paramsNames: [ROUTER_PARAMS_NAMES.workspace],
                permissions: [PERMISSION_NAMES.view_tcpa_shield],
                icon: () => TcpaShieldIcon,
            },
            {
                id: 52,
                name: 'Blocked Numbers',
                routeName: ROUTES.blockNumber,
                paramsNames: [ROUTER_PARAMS_NAMES.workspace],
                permissions: [PERMISSION_NAMES.view_blocked_numbers],
                icon: () => BlockedNumbersIcon,
            },
        ],
    },
]

export const CALL_MENU_ROUTES_BUYER = [
    reporting,
    { divider: true, id: 'd-top' },
    {
        section: 'TRACKING',
        id: 's-tracking',
        isOpenSection: true,
        isFirstLoadSection: true,
        items: [
            {
                id: 14,
                name: 'Destinations',
                routeName: ROUTES.manageDestinations,
                paramsNames: [ROUTER_PARAMS_NAMES.workspace],
                icon: () => DestinationIcon,
            },
        ],
    },
    { divider: true, id: 'd-tracking' },
    {
        section: 'EXCHANGE',
        id: 's-exchange',
        isOpenSection: true,
        isFirstLoadSection: true,
        items: [
            {
                id: 32,
                name: 'Disputes',
                routeName: ROUTES.disputes,
                paramsNames: [ROUTER_PARAMS_NAMES.workspace],
                permissions: [PERMISSION_NAMES.dispute_enabled],
                icon: () => DisputeIcon,
            },
        ],
    },
]

export const CALL_MENU_ROUTES_VENDOR = [
    reporting,
    { divider: true, id: 'd-top' },
    {
        section: 'TRACKING',
        id: 's-tracking',
        isOpenSection: true,
        isFirstLoadSection: true,
        items: [
            {
                id: 2,
                name: 'Campaigns',
                routeName: ROUTES.manageCampaigns,
                paramsNames: [ROUTER_PARAMS_NAMES.workspace],
                permissions: [PERMISSION_NAMES.manage_traffic],
                icon: () => CampaignIcon,
            },
            {
                id: 12,
                name: 'Tracking Numbers',
                routeName: ROUTES.manageNumbers,
                paramsNames: [ROUTER_PARAMS_NAMES.workspace],
                icon: () => TrackingNumbersIcon,
            },
            {
                id: 13,
                name: 'Number Pools',
                routeName: ROUTES.managePools,
                paramsNames: [ROUTER_PARAMS_NAMES.workspace],
                icon: () => NumberPoolsIcon,
            },
            // {
            //     id: 15,
            //     name: 'Offers',
            //     routeName: ROUTES.manageOffers,
            //     paramsNames: [ROUTER_PARAMS_NAMES.workspace],
            //     icon: () => OffersIcon,
            // },
            // {
            //     id: 16,
            //     name: 'Requests',
            //     routeName: ROUTES.manageRequests,
            //     paramsNames: [ROUTER_PARAMS_NAMES.workspace],
            //     icon: () => RequestsIcon,
            // },
        ],
    },
    { divider: true, id: 'd-tracking' },
    {
        section: 'Connections',
        id: 's-connections',
        isOpenSection: true,
        isFirstLoadSection: true,
        items: [
            {
                id: 21,
                name: 'Traffic Sources',
                routeName: ROUTES.manageTrafficSources,
                paramsNames: [ROUTER_PARAMS_NAMES.workspace],
                permissions: [PERMISSION_NAMES.manage_traffic],
                icon: () => TrafficSourceIcon,
            },
            {
                id: 10,
                name: 'Integrations',
                routeName: ROUTES.manageIntegrations,
                paramsNames: [ROUTER_PARAMS_NAMES.workspace],
                permissions: [PERMISSION_NAMES.manage_traffic],
                icon: () => IntegrationIcon,
            },
            {
                id: 13,
                name: 'Lead Details',
                routeName: ROUTES.manageLeads,
                paramsNames: [ROUTER_PARAMS_NAMES.workspace],
                permissions: [PERMISSION_NAMES.manage_traffic],
                icon: () => LeadsIcon,
            },
        ],
    },
]
